import * as c from 'constants/actionTypes/billing';

export const activatePlan = (planId) => ({
  type: c.ACTIVATE_PLAN,
  payload: planId,
});

export const getPlans = (token, appId) => ({
  type: c.GET_PLANS,
  payload: { token, appId },
});

export const confirmCharge = (externalChargeId) => ({
  type: c.CONFIRM_CHARGE,
  payload: externalChargeId,
});
